import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';

import { Router, ActivatedRoute } from '@angular/router';
import { first } from 'rxjs/operators';
import { NgxSpinnerService } from 'ngx-spinner';

import { AlertService, VerifystudentService, AuthenticationService } from '../_services';
import { Globals } from '../_helpers';


export class MyErrorStateMatcher implements ErrorStateMatcher {
    isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
        const isSubmitted = form && form.submitted;
        return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
    }
}

@Component({
    selector: 'feedback-start',
    templateUrl: './feedback-start.component.html',
})

export class FeedbackstartComponent {
    trainernameFormControl = new FormControl('', [
        Validators.required,
        Validators.minLength(3),
    ]);
    emailFormControl = new FormControl('', [
        Validators.required,
        Validators.pattern("[^ @]*@[^ @]*"),
    ]);
    mobileFormControl = new FormControl('', [
        Validators.required,
        //Validators.minLength(10),
        Validators.pattern("[0-9]{10}"),
    ]);
    traindateFormControl = new FormControl('', [
        Validators.required,
        Validators.minLength(9),
    ]);
    matcher = new MyErrorStateMatcher();

    loading = false;
    submitted = false;
    isErrorLogin = false;
    errorMsg: string;
    returnUrl: string;
    userData = {};
    feedback_id: number;   
    feedback_student_id: number;   
    feedbackdone: number;           
    enroll_no: string;          
    batch_name: string;           
    center_id : string;          
    tc_name: string;
    student_name: string;
    settings = {};
    minDate: Date;
    maxDate: Date;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private verifystudentService: VerifystudentService,
        private alertService: AlertService,
        private authenticationService: AuthenticationService,         
        private globals: Globals,
        private spinner: NgxSpinnerService
    ) {
        const d = new Date();
        const currentYear = new Date().getFullYear();
        this.minDate = new Date(currentYear - 5, 0, 1);
        this.maxDate = new Date(currentYear, d.getMonth(), d.getDate() - 1);
    }


    ngOnInit() {
        var step = this.route.snapshot.paramMap.get("step");
        //if (step != this.globals.complSteps['feedback-start'])
            //this.router.navigateByUrl('/login');
            //this.userData = JSON.parse(localStorage.getItem('currentUser'));
            //console.log(this.userData);
            // get return url from route parameters or default to '/'
            //this.returnUrl = '/';
/*            console.log(step);
            return;*/
        this.userData = JSON.parse(localStorage.getItem('currentUser'));
        this.settings = JSON.parse(sessionStorage.pkshn_exam_set);         
        this.getFeedback();
    }


    public getFeedback() {
        this.verifystudentService.getFeedbackInfo(this.globals.root_url, this.userData['usercode'], this.userData['id'], this.settings['exam_id'])
          .pipe(first())
          .subscribe(
            data => {
              if (data.code == 1000) {
                    this.feedback_id = data.feedback_id;             
                    this.feedbackdone = data.feedbackdone;             
                    this.enroll_no = data.enroll_no;             
                    this.batch_name = data.batch_name;             
                    this.center_id = data.center_id;             
                    this.tc_name = data.tc_name;             
                    this.student_name = this.userData['name']; 
                    let sett = { 'feedbackid': this.feedback_id, 'feedback_status': this.feedbackdone };
                    sessionStorage.setItem('pkshn_feedback_set', JSON.stringify(sett)); 
                    if(this.feedbackdone == 1)
                    {
                        var parms = this.globals.getRandUrl('test-start');
                        this.router.navigateByUrl('/test-start/' + parms); 
                    }                                 
              }
              else if (data.code == 1001) {
                this.loading = false;
                this.isErrorLogin = false;
                //this.router.navigateByUrl('/login');
              }
            }
          )
    }
    public onSubmit() {
        this.submitted = true;
        if (this.trainernameFormControl.valid == false || this.emailFormControl.valid == false || this.mobileFormControl.valid == false || this.traindateFormControl.valid == false) {
            this.isErrorLogin = false;
            return false;
        }
        else {
            this.loading = true;
            this.spinner.show();
            this.verifystudentService.setFeedbackInfo(this.globals.root_url, this.userData['usercode'], this.userData['id'], this.settings['exam_id'], this.feedback_id, this.emailFormControl.value, this.mobileFormControl.value, this.trainernameFormControl.value, this.traindateFormControl.value)
              .pipe(first())
              .subscribe(
                data => {
                  if (data.code == 1000) {
                        this.feedback_id = data.feedback_id;             
                        this.feedback_student_id = data.feedback_student_id; 
                        this.authStage();
                        var params = this.feedback_student_id + '@@' + this.feedback_id
                        this.router.navigateByUrl('/feedback/' + params);
                  }
                  else if (data.code == 1001) {
                    this.loading = false;
                    this.isErrorLogin = false;
                    //this.router.navigateByUrl('/login');
                  }
                }
              )            
        }
    }    
    public authStage(){
        this.authenticationService.authStage(this.globals.root_url, this.userData['usercode'], this.userData['id'], this.settings['exam_id'], 5)
        .pipe(first())
        .subscribe(
            data => {
                if(data.code == 1000){
                    console.log('Auth Stage 5 updated');
                }
            }
        );
    }    
}
